// extracted by mini-css-extract-plugin
export var wrapperStyle = "search_refine_multi_select_checkbox_option_flag-module--wrapperStyle--qHt01";